<template>
    <div class="content_box mobile_content">
        <div class="content">
            <div class="title_box">
                <div class="title">
                    <span>猫砂卡管理</span>
                </div>
            </div>
            <div class="search_box">
                <el-form :inline="true" :model="searchData" class="demo-form-inline search-form form-list">
                    <el-form-item label="激活码/手机号/订单号" class="form_item form_item_big">
                        <el-input placeholder="请输入" clearable v-model="searchData.code"></el-input>
                    </el-form-item>
                    <el-form-item label="状态" class="form_item">
                        <el-select v-model="searchData.status" filterable placeholder="状态">
                            <el-option label="全部" value="-1"></el-option>
                            <el-option label="未发放" value="0"></el-option>
                            <el-option label="已发放" value="1"></el-option>
                            <el-option label="已作废" value="2"></el-option>
                            <el-option label="已完结" value="3"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div class="button search" @click="search">
                            <span>查询</span>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div class="btn_box">
                <div class="button import" @click="openCreateDialog()" v-if="roleCheck('105-102-101-104')">
                    <span>新增</span>
                </div>
            </div>
            <el-table
                highlight-current-row
                :data="listData">
                <el-table-column prop="order_id" label="平台订单号"></el-table-column>
                <el-table-column prop="push_platform" label="店铺"></el-table-column>
                <el-table-column prop="paytime" label="订单支付时间" width="160"></el-table-column>
                <el-table-column prop="card_code" label="激活码" ></el-table-column>
                <el-table-column label="是否发放">
                    <template slot-scope="scope" >
                        <span class="end" v-if="scope.row.status === 3">已完结</span>
                        <span class="invalid" v-if="scope.row.status === 2">已作废</span>
                        <span class="send" v-if="scope.row.status === 1">已发放</span>
                        <span class="unissued" v-if="scope.row.status === 0">未发放</span>
                    </template>
                </el-table-column>
                
                
                <el-table-column prop="push_phone" label="发放手机号"></el-table-column>
                <el-table-column label="发放时间" width="160">
                    <template slot-scope="scope" >
                        <span>{{formDate(scope.row.push_time)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否激活">
                    <template slot-scope="scope" >
                        <span :class="{active: scope.row.active_status}">{{scope.row.active_status ? '已激活' : '未激活'}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="redeem_num" label="首次发放袋数" width="110">
                    <template slot-scope="scope" >
                        <span>{{ scope.row.init_num || '' }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="redeem_num" label="兑换袋数">
                    <template slot-scope="scope" >
                        <span>{{ scope.row.redeem_num + '/' + scope.row.redeem_total }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180">
                    <template slot-scope="scope" >
                        <div class="button text" @click="openUpdateDialog(scope.row, 2)" v-if="roleCheck('105-102-101-103') && scope.row.status === 1">作废</div>
                        <div class="button text" @click="openUpdateDialog(scope.row, 1)" v-if="roleCheck('105-102-101-102') && scope.row.status === 0">发放</div>
                        <div class="button text" @click="openUpdateDialog(scope.row, 3)" v-if="roleCheck('105-102-101-102') && scope.row.status === 1">编辑</div>
                        <div class="button text" @click="openUpdateDialog(scope.row, 4)" v-if="roleCheck('105-102-101-102') && (scope.row.cycle_status === 1 || scope.row.cycle_status === 0)">周期兑</div>
                    </template>
                </el-table-column>
            </el-table>
            <Pagination :total="total" :page="searchData.page" @paginationChange="paginationChange"></Pagination>
        </div>
        <Gh-Dialog ref="activationCode" size="big" title="新增猫砂卡" @dialogBack="creatOrder">
            <template v-slot:content>
                <el-form label-width="120px" :model="createData" class="createForm" ref="createForm" :rules="sendFormRule">
                    <el-form-item label="店铺" prop="platform">
                        <el-select v-model="createData.platform" placeholder="请选择店铺">
                            <el-option v-for="item in platform" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单号" prop="order_id">
                        <el-input v-model.trim="createData.order_id" placeholder="请输入订单号"></el-input>
                    </el-form-item>
                    <el-form-item label="发放手机号" prop="push_phone">
                        <el-input v-model.trim="createData.push_phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="订单支付时间" prop="paytime">
                        <el-date-picker v-model="createData.paytime" type="datetime" :editable="true"
                            format="yyyy-MM-dd HH:mm:ss" placeholder="请选择订单支付时间"
                            value-format="yyyy-MM-dd HH:mm:ss" popper-class="time">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="首次发放袋数" prop="init_num" >
                        <el-input class="number_input" v-model.number="createData.init_num" placeholder="请输入首次发放袋数"></el-input>
                    </el-form-item>
                    <el-form-item label="已发放袋数" prop="redeem_num">
                        <el-input class="number_input" v-model.number="createData.redeem_num" placeholder="请输入已发放袋数"></el-input>
                    </el-form-item>
                    <el-form-item label="总袋数" prop="redeem_total">
                        <el-input class="number_input" v-model.number="createData.redeem_total" placeholder="请输入总袋数"></el-input>
                        <span>注意：10kg 为一袋</span>
                    </el-form-item>
                    <el-form-item label="线上店铺订单">
                        <el-radio v-model="createData.is_new" :label="0">是</el-radio>
                        <el-radio v-model="createData.is_new" :label="1">否</el-radio>
                    </el-form-item>
                </el-form>
            </template>
        </Gh-Dialog>
        <Gh-Dialog ref="sendCode" title="绑定手机号" @dialogBack="sendCode">
            <template v-slot:content>
                <el-form label-width="100px" :model="sendData" ref="sendForm" :rules="sendFormRule">
                    <el-form-item label="订单号" prop="order_id">
                        <span>{{ sendData.order_id }}</span>
                    </el-form-item>
                    <el-form-item label="手机号" prop="push_phone">
                        <el-input v-model.trim="sendData.push_phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    
                </el-form>
            </template>
        </Gh-Dialog>
        <Gh-Dialog ref="editCode" title="编辑" @dialogBack="editCode">
            <template v-slot:content>
                <el-form label-width="110px" :model="editData" ref="sendForm" :rules="sendFormRule">
                    <el-form-item label="订单号" prop="order_id">
                        <span>{{ editData.order_id }}</span>
                    </el-form-item>
                    <el-form-item label="激活码" prop="order_id">
                        <span>{{ editData.card_code }}</span>
                    </el-form-item>
                    <el-form-item label="手机号" prop="push_phone">
                        <el-input v-model.trim="editData.push_phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="首次发放袋数" prop="init_num" >
                        <el-input class="number_input" v-model.number="editData.init_num" placeholder="请输入首次发放袋数"></el-input>
                    </el-form-item>
                    <el-form-item label="已兑换袋数">
                        <el-select v-model="editData.redeem_num" placeholder="请选择数量">
                            <el-option v-for="item in (totalNumber+1)" :key="item" :label="item-1" :value="item-1"></el-option>
                        </el-select>
                        <span>注意：10kg 为一袋</span>
                    </el-form-item>
                </el-form>
            </template>
        </Gh-Dialog>
        <Gh-Dialog ref="cycle" title="周期兑" @dialogBack="editCycle">
            <template v-slot:content>
                <el-form label-width="100px" :model="sendData" ref="sendForm">
                    <el-form-item label="订单号" prop="order_id">
                        <span>{{ editCycleData.order_id }}</span>
                    </el-form-item>
                    <el-form-item label="激活码" prop="order_id">
                        <span>{{ editCycleData.card_code }}</span>
                    </el-form-item>
                    <el-form-item label="发货周期" >
                        <el-cascader v-model="cycleValue" :options="cycleOption" @change="cascaderChange"></el-cascader>
                    </el-form-item>
                    <el-form-item label="下次发货日期">
                        <span>{{ editCycleData.next_date }}</span>
                    </el-form-item>
                    <el-form-item label="兑换袋数" prop="push_phone">
                        <el-select v-model="editCycleData.cycle_num" placeholder="请选择数量">
                            <el-option v-for="item in remainingNumber" :key="item" :label="item" :value="item"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收货地址" prop="order_id">
                        <span>{{ (editCycleData.redeem_area +  editCycleData.redeem_address) || '' }}</span>
                    </el-form-item>
                    <el-form-item label="周期计划" prop="order_id">
                        <el-radio v-model="editCycleData.status" :label="1">开启</el-radio>
                        <el-radio v-model="editCycleData.status" :label="0">暂停</el-radio>
                    </el-form-item>
                </el-form>
            </template>
        </Gh-Dialog>
        <Tip ref="tip" title="作废订单" :msg="tipMsg">
            <template v-slot:confirm_btn>
                <div class="button del" @click="invalidCode">
                    <span>确定</span>
                </div>
            </template>
        </Tip>
    </div>
</template>
<script>
export default({
    name: 'activation-code',
    data() {
        return {
            searchData: {
                code: '',
                status: '-1',
                page: 1,
                page_size: 10
            },
            productType: [],
            listData: [],
            total: 0,
            createData: {
                platform: '',
                order_id: '',
                push_phone: '',
                paytime: '',
                init_num: 0,
                redeem_num: 0,
                redeem_total: 18,
                is_new: 0
            },
            platform: ['天猫-宜宝旗舰店', '抖音-宜宝智能电器旗舰店', '京东-宜宝旗舰店', '视频号-宜宝小店', '其他'],
            sendData: {
                platform: '',
                push_phone: '',
                order_id: ''
            },
            totalNumber: 16,
            remainingNumber: 16,
            editData: {
                order_id: '',
                push_platform: '',
                push_phone: '',
                redeem_num: ''
            },
            cycleOption:[],
            cycleValue: [],
            editCycleData: {

            },
            tipMsg: '',
            sendFormRule: {
                platform: [this.requiredRule('请选择店铺')],
                push_phone: [this.requiredRule('请输入手机号')],
                order_id: [this.requiredRule('请输入平台订单号')],
                init_num: [this.requiredRule('请输入首次发放袋数')],
                redeem_num: [this.requiredRule('请输入已发放袋数')],
                redeem_total: [this.requiredRule('请输入总袋数')],
                paytime: [this.requiredRule('请选择订单支付时间')],
            },
        }
    },
    watch: {
    },
    created() {
        this.getList();
        this.cycleOption = [
            {
                value: 0,
                label: '每周',
                children: this.initCycleData(0)
            },{
                value: 1,
                label: '每两周',
                children: this.initCycleData(1)
            },{
                value: 2,
                label: '每月',
                children: this.initCycleData(2)
            }
        ];
    },
    methods: {
        search() {
            this.searchData.page = 1;
            this.getList();
        },
        initCycleData(type) { //初始化周期兑周期选项数据
            let cycleValueData = [];
            const week = ['周一','周二','周三','周四','周五','周六','周日'];
            if(type == 2) { //每月
                for(let i = 1;i<=28;i++) {
                    cycleValueData.push({
                        value: i,
                        label: i + '号'
                    })
                }
            }else{
                for(let i = 0;i<7;i++) {
                    cycleValueData.push({
                        value: i+1,
                        label: week[i]
                    })
                }
            }
            return cycleValueData;
        },
        getList() {
            this.api.getClcCode(this.searchData).then(data => {
                this.listData = data.data.list;
                this.total = data.data.total;
            })
        },
        paginationChange(data) {
            this.searchData.page_size = data.page_size;
            this.searchData.page = data.page;
            this.getList();
        },
        openCreateDialog() {
            this.$refs.activationCode.show = true;
        },
        openUpdateDialog(item, state) {
            this.sendData = {};
            this.sendData.order_id = item.order_id;
            this.sendData.card_code = item.card_code;
            this.totalNumber = item.redeem_total;
            this.remainingNumber = item.redeem_total - item.redeem_num;
            if(state == 1) { //发放
                this.$refs.sendCode.show = true;
            }else if(state == 2) { //作废
                this.tipMsg = `确定作废订单： ${item.order_id} `
                this.$refs.tip.show = true;
            }else if(state == 3){ //编辑
                this.editData = {
                    order_id: item.order_id,
                    card_code: item.card_code,
                    push_platform: item.push_platform,
                    push_phone: item.push_phone,
                    redeem_num: item.redeem_num,
                    init_num: item.init_num
                };
                this.$refs.editCode.show = true;
            }else if(state == 4){ //周期兑编辑
                this.editCycleData = {
                    push_phone: item.push_phone,
                    order_id: item.order_id,
                    card_code: item.card_code,
                    cycle_id: item.cycle_id,
                    status: item.cycle_status,
                    first_date: item.first_date,
                    next_date: item.next_date,
                    cycle_num: item.cycle_num,
                    cycle_rate: item.cycle_rate,
                    redeem_area: item.redeem_area,
                    redeem_address: item.redeem_address
                };
                this.setCycleValue();
                this.$refs.cycle.show = true;
            }
        },
        setCycleValue() {
            const value = this.countDate(this.editCycleData.cycle_rate,this.editCycleData.next_date);
            this.cycleValue = [this.editCycleData.cycle_rate, value];
        },
        countDate(type, time) {
            const date = new Date(time);
            if(type == 2) {  //按月
                return date.getDate();
            }else{
                return date.getDay() == 0 ? 7 : date.getDay();
            }
        },
        creatOrder() {
            this.$refs.createForm.validate(v => {
                if(v) {
                    this.api.createClcOrder(this.createData).then(data => {
                        this.search();
                        this.$refs.activationCode.show = false;
                        this.createData = {  //初始化
                            platform: '',
                            order_id: '',
                            push_phone: '',
                            paytime: '',
                            init_num: 0,
                            redeem_num: 0,
                            redeem_total: 18,
                            is_new: 0
                        };
                    })
                }
            })
        },
        sendCode() {
            this.$refs.sendForm.validate(v => {
                if(v) {
                    this.api.pushClcCode(this.sendData).then(data => {
                        this.getList();
                        this.$refs.sendCode.show = false;
                    })
                }
            })
        },
        editCode() {
            this.$refs.sendForm.validate(v => {
                if(v) {
                    // this.editData.redeem_num = parseInt(this.editData.redeem_num);
                    this.api.updateClcCode(this.editData).then(data => {
                        this.getList();
                        this.$refs.editCode.show = false;
                    })
                }
            })
        },
        cascaderChange(value) {
            // 获取当前日期
            const currentDate = new Date();
            if(value[0] == 2){  //按月
                // 获取当前年月日
                const currentYear = currentDate.getFullYear();
                const currentMonth = currentDate.getMonth();
                const currentDay = currentDate.getDate();

                if(currentDay < value[1]) {  //当前月开始
                    this.editCycleData.first_date = currentYear + '-' + (currentMonth + 1) + '-' + value[1];
                }else{  //下个月开始
                    // 计算下个月的年份和月份
                    let nextMonth;
                    let nextYear;

                    if (currentMonth === 11) {
                        nextMonth = 0; // 如果当前月份是12月，下个月为1月
                        nextYear = currentYear + 1; // 年份加1
                    } else {
                        nextMonth = currentMonth + 1;
                        nextYear = currentYear;
                    }
                    this.editCycleData.first_date = nextYear + '-' + (nextMonth + 1) + '-' + value[1];
                    this.editCycleData.first_date = this.formDate(new Date(this.editCycleData.first_date).getTime(), 'YYYY-MM-DD');
                }
            }else{ //每两周、每周
                const currentWeek = currentDate.getDay() == 0 ? 7 : currentDate.getDay();
                let numberOfDaysToAdd = 0;
                if(currentWeek < value[1]) { //本周发货
                    numberOfDaysToAdd = value[1] - currentWeek;
                }else{ //下周发货
                    numberOfDaysToAdd = 7 - (currentWeek - value[1]);
                }
                currentDate.setDate(currentDate.getDate() + numberOfDaysToAdd);
                this.editCycleData.first_date = this.formDate(currentDate.getTime(), 'YYYY-MM-DD');
            }
            this.editCycleData.next_date = this.editCycleData.first_date;
            this.editCycleData.cycle_rate = value[0];
        },
        editCycle() {
            this.api.updateClcCycle(this.editCycleData).then(data => {
                this.getList();
                this.$refs.cycle.show = false;
            })
        },
        invalidCode() {
            this.api.delClcCode(this.sendData).then(data => {
                this.getList();
                this.$refs.tip.show = false;
            })
        }
    }
})
</script>
<style lang="less" scoped>
    .invalid{
        color: #EB534B;
    }
    .send{
        color: #2A79FF;
    }
    .active{
        color: #32b312;
    }
    .end{
        color: #667a9b;
    }
    .el-form.form-list{
        /deep/.form_item.form_item_big{
            .el-form-item__label{
                width: 170px;
            }
            .el-input__inner{
                width: 210px;
            }
        }
    }
    .createForm{
        .el-form-item{
            margin-bottom: 15px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/view/product/cat-litter-card/activation-code-manage.vue